import React from 'react'

export default function PricingNote({ style, className }) {
  return (
    <div style={style} className={className}>
      <div className="requester-flow-estimate-price">
        <div className="dome-d-flex dome-gap6 dome-align-baseline">
          <span className="dome-h2 dome-color-dark-green dome-text-w500">$XX.xx</span>
          <span className="dome-p3 dome-color-med-grey">estimated price</span>
        </div>
      </div>
      <span className="dome-p3 dome-text-style-italic dome-color-med-grey dome-text-w300">
        All pricing set by property management + subject to change.
      </span>
    </div>
  )
}
